module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-sm-8 m-sm-auto col-md-5 m-md-auto"
  }, [_c('h2', {
    staticClass: "text-center py-3 py-sm-5"
  }, [_vm._v("ログイン")]), _vm._v(" "), _c('form', {
    staticClass: "form-group",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "userID"
    }
  }, [_vm._v("ユーザー名（メールアドレス）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credencials.email),
      expression: "credencials.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "mail",
      "placeholder": "ユーザー名（メールアドレス）",
      "id": "userID"
    },
    domProps: {
      "value": (_vm.credencials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credencials.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-5"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "pass"
    }
  }, [_vm._v("パスワード")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credencials.password),
      expression: "credencials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "パスワード",
      "id": "pass"
    },
    domProps: {
      "value": (_vm.credencials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credencials.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block mb-5",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("ログイン")]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("パスワードをお忘れの方は"), _c('router-link', {
    attrs: {
      "to": "/password"
    }
  }, [_vm._v("コチラ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5457ef93!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/Login.vue
// module id = 335
// module chunks = 1